export default __webpack_public_path__ + "static/media/eye.7bd7e517.svg";